var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy"}],class:[_vm.$style.button, ( _obj = {}, _obj[_vm.$style.newMessage] = _vm.newMessage, _obj )],attrs:{"title":"Live coach"},on:{"click":_vm.handleClick}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faBolt}})],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71b58899","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rep-call/toolbar/live-coach-chat-button/live-coach-chat-button.vue
// module id = KICy
// module chunks = 1